module.exports = __webpack_public_path__ + "static/img/join.515a17d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/join.png
// module id = qxVr
// module chunks = 24